import './About.css'

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-header">
          <p className="section-label">WHO WE ARE</p>
          <h2 className="section-title">
            Technology for the <span className="highlight-green">Masses</span>, Built with Precision.
          </h2>
        </div>

        <div className="about-content">
          <div className="about-text">
            <p className="about-paragraph">
              <strong>Jana (जन)</strong> — Derived from Sanskrit/Hindi, meaning "People," "Public," or "Masses." 
              It signifies that our technology is not for an ivory tower of elites, but for the common man. 
              It implies inclusivity, accessibility, and utility.
            </p>
            <p className="about-paragraph">
              <strong>Code</strong> — The universal language of the modern world. It represents our core strength 
              in SaaS, product development, and the precise engineering required for sectors like Finance, 
              Gaming, and Sports Tech.
            </p>
            <p className="about-paragraph">
              Janacode is a premium SaaS product development company headquartered in India, serving global 
              innovators with world-class engineering. We bridge human-centric design with technical precision 
              to build products that matter.
            </p>
          </div>

          <div className="about-stats">
            <div className="about-stat">
              <span className="stat-value">7+</span>
              <span className="stat-label">Domains</span>
            </div>
            <div className="about-stat-divider"></div>
            <div className="about-stat">
              <span className="stat-value">1</span>
              <span className="stat-label">Live Product</span>
            </div>
            <div className="about-stat-divider"></div>
            <div className="about-stat">
              <span className="stat-value">∞</span>
              <span className="stat-label">Scale</span>
            </div>
            <div className="about-stat-divider"></div>
            <div className="about-stat">
              <span className="stat-value">🇮🇳</span>
              <span className="stat-label">Made in India</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
